import { withLocalState } from 'pyradux';

import TrackingContainer from './Tracking.container';
import reducer from './Tracking.reducer';
import TrackingSagas from './Tracking.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'tracking',
  sagas: [TrackingSagas],
};

export default withLocalState(withLocalStateOptions, TrackingContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Tracking/index.js